import React from "react";

export default function DeleteAccountModal({
  isOpen, onCancel, onConfirm,
  password, setPassword, confirmText, setConfirmText,
  deleting, error,
}) {
  if (!isOpen) return null;

  const canDelete = confirmText === 'DELETE' && password.length > 0 && !deleting;

  return (
    <div className="delete-account-modal-overlay" onClick={onCancel}>
      <div className="delete-account-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Delete account</h2>
        <p className="delete-account-warning">
          This permanently deletes your account, all students, lessons, schedule,
          chat history, homework and dictionary entries, and cancels any active
          subscription. This cannot be undone.
        </p>

        <label>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="delete-account-input"
          placeholder="Current password"
          disabled={deleting}
        />

        <label>Type DELETE to confirm</label>
        <input
          type="text"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          className="delete-account-input"
          placeholder="DELETE"
          disabled={deleting}
        />

        {error && <p className="delete-account-error">{error}</p>}

        <div className="delete-account-buttons">
          <button className="delete-account-cancel-btn" onClick={onCancel} disabled={deleting}>
            Cancel
          </button>
          <button className="delete-account-confirm-btn" onClick={onConfirm} disabled={!canDelete}>
            {deleting ? 'Deleting…' : 'Delete my account'}
          </button>
        </div>
      </div>
    </div>
  );
}
